import { render } from "./indexFr.vue?vue&type=template&id=51eb8e9a&scoped=true&ts=true"
import script from "./indexFr.vue?vue&type=script&lang=ts"
export * from "./indexFr.vue?vue&type=script&lang=ts"

import "./indexFr.vue?vue&type=style&index=0&id=51eb8e9a&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51eb8e9a"]])

export default __exports__